module.exports = __webpack_public_path__ + "static/media/Kai-Armstrong-prof.52e0062b.png";